import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=34242d60&scoped=true&"
import script from "./ProductsChart.vue?vue&type=script&lang=js&"
export * from "./ProductsChart.vue?vue&type=script&lang=js&"
import style0 from "./ProductsChart.vue?vue&type=style&index=0&id=34242d60&lang=css&scoped=true&"
import style1 from "./ProductsChart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34242d60",
  null
  
)

export default component.exports